import React from "react";

const Contact = () => {
  return <div id="contact"></div>;
};

export default Contact;
